import React from 'react';

/**
 * Visualizador de audio profesional tipo ecualizador
 * Simula frecuencias de graves (izquierda) a agudos (derecha)
 */
export const AudioVisualizer = ({ 
  isPlaying = false, 
  bars = 7, 
  size = 'md',
  className = '' 
}) => {
  const sizeConfig = {
    sm: { height: 14, width: 2, gap: 1 },
    md: { height: 18, width: 2, gap: 1.5 },
    lg: { height: 24, width: 3, gap: 2 },
  };
  
  const config = sizeConfig[size] || sizeConfig.md;
  
  // Patrones de altura para simular frecuencias (graves a agudos)
  const barPatterns = [
    { min: 0.4, max: 0.7, duration: 450, delay: 0 },      // Graves bajos - más lentos
    { min: 0.35, max: 0.85, duration: 400, delay: 50 },   // Graves
    { min: 0.3, max: 1.0, duration: 350, delay: 100 },    // Medios-bajos
    { min: 0.35, max: 0.9, duration: 320, delay: 70 },    // Medios
    { min: 0.3, max: 0.8, duration: 300, delay: 50 },     // Medios-altos
    { min: 0.25, max: 0.7, duration: 280, delay: 30 },    // Agudos
    { min: 0.2, max: 0.55, duration: 250, delay: 0 },     // Agudos altos - más rápidos
  ];

  return (
    <div 
      className={`flex items-end justify-center ${className}`}
      style={{ gap: `${config.gap}px`, height: `${config.height}px` }}
    >
      {Array.from({ length: bars }).map((_, i) => {
        const pattern = barPatterns[i % barPatterns.length];
        const minH = config.height * pattern.min;
        const maxH = config.height * pattern.max;
        
        return (
          <span
            key={i}
            className="rounded-full bg-white transition-all"
            style={{
              width: `${config.width}px`,
              height: isPlaying ? `${maxH}px` : `${minH}px`,
              opacity: isPlaying ? 1 : 0.4,
              animation: isPlaying 
                ? `equalizerBar${i} ${pattern.duration}ms ease-in-out ${pattern.delay}ms infinite alternate`
                : 'none',
            }}
          />
        );
      })}
    </div>
  );
};

/**
 * Visualizador compacto para badges pequeños
 */
export const AudioVisualizerMini = ({ isPlaying = false }) => (
  <AudioVisualizer 
    isPlaying={isPlaying} 
    bars={5} 
    size="sm"
  />
);

/**
 * Visualizador para el mini-player
 */
export const AudioVisualizerPlayer = ({ isPlaying = false }) => (
  <AudioVisualizer 
    isPlaying={isPlaying} 
    bars={7} 
    size="md"
  />
);

export default AudioVisualizer;
